import actionTypes from "./actionTypes";

export const projectController = () => {
    return {
        type: actionTypes.PROJECT
    }
}